export const dockConfigurationFieldStyles = {
    wrapper: {
        width: '100%',
        padding: '8px 0',
    },
    row: {
        display: 'flex',
        gap: '10px',
        marginBottom: '8px',
    },
    item: {
        flex: 1,
    },
    label: {
        color: '#333333',
        fontSize: 12,
        marginBottom: 4,
        display: 'block' as const,
    },
    dockMappingWrapper: {
        width: '100%',
        marginTop: 8,
        marginBottom: 8,
    },
};
